(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-overview-selector-score/assets/javascripts/coupon-overview-selector-score.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-overview-selector-score/assets/javascripts/coupon-overview-selector-score.js');
"use strict";


const _React = React,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$components$tipse = svs.components.tipsen.couponComponents,
  Coupon = _svs$components$tipse.Coupon,
  useCouponContext = _svs$components$tipse.useCouponContext;
const DescriptionSize = svs.components.lbUi.participants.constants.DescriptionSize;
const getOutcomeLabelsForEventType = svs.components.sport.tipsenShared.getOutcomeLabelsForEventType;
const _svs$components$tipse2 = svs.components.tipsen.engine.selectors.couponSelectors,
  makeSelectEventOutcomesFromBitmap = _svs$components$tipse2.makeSelectEventOutcomesFromBitmap,
  selectIsCouponExternal = _svs$components$tipse2.selectIsCouponExternal;
const _svs$components$tipse3 = svs.components.tipsen.drawProvider.hooks,
  useCurrentDraw = _svs$components$tipse3.useCurrentDraw,
  useCurrentDrawEvent = _svs$components$tipse3.useCurrentDrawEvent;
const CouponOverviewReduce = svs.components.tipsen.couponOverviewParts.CouponOverviewReduce;
const CouponOverviewExternal = svs.components.tipsen.couponOverviewExternal.CouponOverviewExternal;
const clx = svs.components.lbUtils.clx;
const CouponOverviewRow = _ref => {
  let awayParticipant = _ref.awayParticipant,
    eventNumber = _ref.eventNumber,
    homeParticipant = _ref.homeParticipant,
    nameSize = _ref.nameSize;
  const _ref2 = useCurrentDraw() || {},
    productId = _ref2.productId,
    sportType = _ref2.sportType;
  const _ref3 = useCurrentDrawEvent() || {},
    eventTypeId = _ref3.eventTypeId;
  const _useCouponContext = useCouponContext(),
    couponId = _useCouponContext.couponId;
  const outcomeLabels = useMemo(() => getOutcomeLabelsForEventType(eventTypeId, sportType, productId), [eventTypeId, productId, sportType]);
  const selectOutcomes = useMemo(makeSelectEventOutcomesFromBitmap, []);
  const boardIndex = 0;
  const selectionsHome = useSelector(state => selectOutcomes(state, couponId, boardIndex, eventNumber, 0));
  const selectionsAway = useSelector(state => selectOutcomes(state, couponId, boardIndex, eventNumber, 1));
  const outcomesHome = useMemo(() => {
    const outcomesArray = outcomeLabels.map((outcome, index) => ({
      sign: outcome.text,
      isSelected: Boolean(selectionsHome[index])
    }));
    return [...outcomesArray];
  }, [outcomeLabels, selectionsHome]);
  const outcomesAway = useMemo(() => {
    const outcomesArray = outcomeLabels.map((outcome, index) => ({
      sign: outcome.text,
      isSelected: Boolean(selectionsAway[index])
    }));
    return [...outcomesArray];
  }, [outcomeLabels, selectionsAway]);
  return React.createElement("div", {
    className: "pg_coupon_overview_row"
  }, React.createElement("div", {
    className: "pg_coupon_overview_row__home_participant"
  }, React.createElement(Coupon.Participant, {
    nameSize: nameSize,
    participant: homeParticipant
  })), React.createElement("div", {
    className: "pg_coupon_overview_row__home_selections"
  }, React.createElement(Coupon.OutcomeRow, {
    boardIndex: boardIndex,
    className: "pg_coupon_overview_row__bet_buttons_grid",
    eventNumber: eventNumber,
    outcomeGroupIndex: 0,
    outcomes: outcomesHome
  })), React.createElement("div", {
    className: "pg_coupon_overview_row__away_participant"
  }, React.createElement(Coupon.Participant, {
    nameSize: nameSize,
    participant: awayParticipant
  })), React.createElement("div", {
    className: "pg_coupon_overview_row__away_selections"
  }, React.createElement(Coupon.OutcomeRow, {
    boardIndex: boardIndex,
    eventNumber: eventNumber,
    outcomeGroupIndex: 1,
    outcomes: outcomesAway
  })), React.createElement("div", {
    className: "pg_coupon_overview_row__reductions"
  }, React.createElement(CouponOverviewReduce, {
    eventNumber: eventNumber
  })));
};
const CouponOverviewSelectorScore = _ref4 => {
  let _ref4$isCompact = _ref4.isCompact,
    isCompact = _ref4$isCompact === void 0 ? false : _ref4$isCompact;
  const _useCouponContext2 = useCouponContext(),
    couponRows = _useCouponContext2.couponRows,
    couponId = _useCouponContext2.couponId;
  const isExternal = useSelector(state => selectIsCouponExternal(state, couponId));
  const blockName = 'pg_coupon_overview_selector';
  const classNames = clx(blockName, "".concat(blockName, "--show-selected"), {
    ["".concat(blockName, "--compact")]: isCompact,
    'margin-xs-h-1': !isCompact
  });
  if (isExternal) {
    return React.createElement("div", {
      className: classNames
    }, React.createElement(CouponOverviewExternal, null));
  }
  return React.createElement("div", {
    className: classNames
  }, couponRows.map(row => React.createElement(CouponOverviewRow, {
    awayParticipant: row.awayParticipant,
    eventNumber: row.eventNumber,
    homeParticipant: row.homeParticipant,
    key: row.eventNumber,
    nameSize: isCompact ? DescriptionSize.Short : DescriptionSize.Full
  })));
};
setGlobal('svs.components.tipsen.couponOverviewSelectorScore.CouponOverviewSelectorScore', CouponOverviewSelectorScore);

 })(window);